export const data = {
    userType: [
        {
            value: '0',
            label: '管理员'
        }, {
            value: '1',
            label: '员工'
        }, {
            value: '2',
            label: '商家'
        }/*, {
            value: '3',
            label: '工程师'
        }, {
            value: '4',
            label: '用户'
        }*/
    ],
    pickerOPtions: {
        shortcuts: [{
            text: '最近一周',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近一个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近三个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
            }
        }]
    },
    serviceType: ['上门服务', '到点服务', '上门/到店'],
    orderStatus: ['已退订', '未指派', '已指派', '已完成', '已评价'],
    orderType: [
        {
            label: '未指派',
            value: 0
        }, {
            label: '已指派',
            value: 1
        }, {
            label: '已完成',
            value: 2
        }, {
            label: '已评价',
            value: 3
        }
    ],
    applyCashType: [
        {
            label: '未处理',
            value: 0
        },
        {
            label: '同意',
            value: 1
        }, {
            label: '拒绝',
            value: 2
        }

    ],
    merchantPayState: ['未支付', '已支付'],
    masterPayState: ['未支付', '私下支付', '转入个人余额'],
    merchantPayStateJSON: [{
        label: '已支付',
        value: 1
    }, {
        label: '未支付',
        value: 0
    }],

    level: [
        {
            label: '1星工程师',
            value: 0
        },
        {
            label: '2星工程师',
            value: 1
        },
        {
            label: '3星工程师',
            value: 2
        },
        {
            label: '4星工程师',
            value: 3
        },
        {
            label: '5星工程师',
            value: 4
        },
        {
            label: '六星加盟店',
            value: 5
        },
        {
            label: '六星连锁店',
            value: 6
        }, {
            label: '荣康7星店',
            value: 7
        }, {
            label: '施工点',
            value: 8
        }, {
            label: '虚假工程师',
            value: 9
        },
        {
            label: '黑名单',
            value: 10
        }
    ],
    interview: ['电话面试', '现场面试'],
    type: [
        {
            label: "获得金额",
            value: 1
        },
        {
            label: "扣除金额",
            value: 0
        }
    ],
    masterMoneyType:[
        {
            label: "增加",
            value: 1
        },
        {
            label: "提现",
            value: 0
        }
    ],
    vip: [
        {
            label: "是",
            value: 1
        },
        {
            label: "否",
            value: 0
        }
    ],
    vipLabel: ['否', '是'],
    payType: ['支付宝', '微信'],
    productType: [{
        label: "疝气大灯",
        value: 0
    }, {
        label: "刹车片",
        value: 1
    }, {
        label: "蓄电池",
        value: 2
    }, {
        label: "DVD导航",
        value: 3
    }, {
        label: "行车记录仪",
        value: 4
    }, {
        label: "倒车雷达",
        value: 5
    }, {
        label: "喇叭音响",
        value: 6
    }, {
        label: "记录仪",
        value: 7
    }, {
        label: "保养",
        value: 8
    }, {
        label: "关窗器",
        value: 9
    }, {
        label: "车载电器",
        value: 10
    }, {
        label: "360度全景俯视系统",
        value: 11
    }, {
        label: "汽车座套",
        value: 12
    }],
    state: [{
        label: "上架",
        value: 0
    }, {
        label: "下架",
        value: 1
    }, {
        label: "删除或过期",
        value: 2
    }],
    productLevel: [{
        label: "高级及以上",
        value: 0
    }, {
        label: "资深及以上",
        value: 1
    }, {
        label: "专家",
        value: 2
    }, {
        label: "精装VIP",
        value: 3
    },],

    areas: [{
        label: "冀辽吉黑浙蒙",
        value: '10,18,15,12,31,19'
    }, {
        label: "川皖鲁湘鄂桂闽宁豫",
        value: '26,3,22,14,13,7,4,20,11'
    }, {
        label: "津沪琼滇赣苏新藏青",
        value: '27,25,9,30,17,16,29,28,21'
    },{
        label: "粤渝京",
        value: '6,32,2'
    },{
        label: "晋贵陕甘",
        value: '23,8,24,5'
    }]


}


// WEBPACK FOOTER //
// ./src/common/data/index.js